import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';
import PhdFormBuilder from '../PhdFormBuilder';
import PhdHelpHint from '../../../../common/Phd/PhdHelpHint.jsx';

const PhdStudySubjectsEditForm = ({ studyFieldOptions, isSubmitting }) => {
  const { t } = useTranslation();
  const subjectTypeOptions = useMemo(
    () => [
      { value: 'required', label: t('Povinný predmet') },
      { value: 'elective', label: t('Výberový predmet') },
    ],
    [t],
  );
  const completionTypeOptions = useMemo(
    () => [
      { value: 'S', label: t('Skúška') },
      { value: 'T', label: t('Štátna skúška') },
      { value: 'V', label: t('Absolvovanie') },
    ],
    [t],
  );

  const sections = useMemo(
    () => [
      {
        key: 'basic',
        title: t('Základné údaje'),
        fields: [
          {
            name: 'code',
            label: t('Kód predmetu'),
            type: 'text',
            rules: [required(t)],
            colSpan: 12,
          },
          {
            name: 'name',
            label: t('Predmet'),
            type: 'text',
            rules: [required(t)],
            colSpan: 12,
          },
          {
            name: 'field_ids',
            label: t('Priradené odbory'),
            type: 'select',
            options: studyFieldOptions,
            rules: [required(t)],
            componentProps: {
              mode: 'multiple',
            },
            colSpan: 12,
          },
          {
            name: 'subject_type',
            label: (
              <span>
                {t('Typ predmetu')}
                <PhdHelpHint
                  label={t('Čo znamená typ predmetu?')}
                  title={t(
                    'Povinný predmet sa do témy a plánu pridáva automaticky. Výberový predmet sa vyberá podľa potreby.',
                  )}
                />
              </span>
            ),
            type: 'select',
            options: subjectTypeOptions,
            rules: [required(t)],
            colSpan: 12,
          },
          {
            name: 'completion_type',
            label: (
              <span>
                {t('Typ ukončenia')}
                <PhdHelpHint
                  label={t('Čo znamená typ ukončenia?')}
                  title={t(
                    'S je skúška, T je štátna skúška a V je absolvovanie. Typ určuje hodnotenie predmetu v pláne.',
                  )}
                />
              </span>
            ),
            type: 'select',
            options: completionTypeOptions,
            rules: [required(t)],
            colSpan: 12,
          },
        ],
      },
    ],
    [completionTypeOptions, studyFieldOptions, subjectTypeOptions, t],
  );

  return (
    <PhdFormBuilder
      sections={sections}
      submitKey="phd-study-subjects"
      isSubmitting={isSubmitting}
    />
  );
};

export default PhdStudySubjectsEditForm;
